import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import CategoryHeader from "../../../../Components/Headers/CategoryHeader";
import { downloadPDF, getDomain } from "./../../../../Utilities/utils";
import axios from "axios";
import Loading from "../../../Components/Loading";
import getTransferData from "../../../CreateQuote/Helpers/getTransferData";
import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import axiosInstance from "../../../../Utilities/djangoAxiosInstance";

const GoDigitDownloadPage = () => {
  const location = useLocation();
  console.log("location: ", location.state);
  const [transactionData] = useSearchParams();
  const navigate = useNavigate();
  const policyStatus = transactionData?.get("policyStatus");
  const policyNumber = transactionData?.get("policyNumber");
  const localSource = location?.state?.source || transactionData?.get("source");
  transactionData.forEach((ele) => console.log(ele));
  const [pdfLinks, setPdfLinks] = useState({});
  const [loading, setLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [transferData, setTransferData] = useState(null);

  // Use an object to track which buttons have been clicked
  const [clickedButtons, setClickedButtons] = useState({
    proposalPath: false,
    schedulePath: false,
    ecardPath: false,
  });

  if (policyStatus === "failure") {
    console.log("policyStatus: ", policyStatus);

    Swal.fire({
      icon: "error",
      title: "Policy Declined!",
      text: "Your policy has been declined to Try Again Click below",
      position: "center",
      showClass: {
        popup: "animate__animated animate__fadeInDown",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutUp",
      },
      confirmButtonText: "Try Again",
    }).then((result) => {
      if (result.isConfirmed) {
        console.log("Policy Declined");
        const stateToPass = {
          source: localSource,
        };
        navigate("/health-insurance", { state: stateToPass });
      }
    });
  }

  useEffect(() => {
    if (policyStatus === "success" && loading) {
      console.log("policyStatus: ", policyStatus);
      const domain = getDomain();
      getTransferData(location?.state?.transferDataId, localSource).then(
        (response) => {
          console.log("transferData: ", response);
          setTransferData(response);
        }
      );
      axiosInstance
        .post(
          `api/health/go-digit/policy-pdf-download/${policyNumber}/`,
          {},
          {
            withCredentials:true
          }
        )
        .then((response) => {
          console.log("pdf links response: ", response);
          if (response?.status === 200) {
            setLoading(false);
            if (response?.data && Object.keys(response.data).length > 0) {
              setPdfLinks(response?.data);
            } else {
              setHasError(true);
            }
          }
        })
        .catch((error) => {
          console.error("Error fetching PDF links:", error);
          setLoading(false);
          setHasError(true);
        });
    }
  }, [policyStatus, policyNumber, loading]);

  useEffect(() => {
    // Check if all three buttons have been clicked at least once
    const allButtonsClicked = Object.values(clickedButtons).every(Boolean);

    if (allButtonsClicked) {
      console.log("Thank you");
      navigate(`/health-insurance/thankyou`);
    }
  }, [clickedButtons]);

  function handleButtonClick(buttonName) {
    console.log(`Clicked on: ${buttonName}`, pdfLinks[buttonName]);
    if (pdfLinks && pdfLinks[buttonName]) {
      const downloadLink = document.createElement("a");
      const fileName = `Acuvisor_${buttonName.replace(/ /g, "_")}.pdf`;
      downloadLink.href = pdfLinks[buttonName];
      downloadLink.download = fileName;
      downloadLink.click();

      // Set the corresponding button as clicked
      setClickedButtons((prevClickedButtons) => ({
        ...prevClickedButtons,
        [buttonName]: true,
      }));
    } else {
      alert("Something went wrong");
      console.error("PDF link not found for", buttonName);
    }
  }

  const handleTryAgain = () => {
    setHasError(false);
    setLoading(true);
  };

  const handleBack = () => {
    console.log("Back to Quick quote");
    const stateToPass = {
      source: localSource,
    };
    navigate("/health-insurance", { state: stateToPass });
  };

  return (
    <div className="flex flex-col justify-center items-center">
      <div className="w-full">
        <CategoryHeader title="Health-insurance" />
      </div>

      {loading ? (
        <Loading />
      ) : (
        <div className="lg:w-3/5">
          {hasError ? (
            <div className="flex flex-col items-center gap-4 justify-center mt-36">
              <div className="font-semibold text-lg text-red-500 mx-2 text-center md:text-base">
                Something went wrong.
                <br /> The Policy PDF couldn't be downloaded.
                <br /> Please try again.
              </div>
              <button
                onClick={handleTryAgain}
                className=" hover:bg-blue-500 bg-blue-800 p-3 text-slate-200 border border-solid border-black rounded-xl text-lg font-semibold h-45 tracking-wide"
              >
                Retry
              </button>
            </div>
          ) : (
            policyStatus === "success" && (
              <div>
                <Container
                  style={{ marginTop: 6, marginBottom: 10 }}
                  maxWidth="sm md lg"
                >
                  <Card
                    className="card-section"
                    sx={{ minWidth: 275, marginTop: 5 }}
                  >
                    <Box sx={{ display: "flex", marginBottom: 4 }}>
                      <img
                        className="bg-white img-thumbnail rounded m-4"
                        width={100}
                        height={100}
                        src={transferData?.logo ?? ""}
                        alt="company_logo"
                      />
                      <Box style={{ marginTop: 28 }}>
                        <Typography>
                          <strong>{transferData?.vendor ?? ""}</strong>
                        </Typography>
                        <Typography>
                          {transferData?.product_name ?? ""}
                        </Typography>
                      </Box>
                    </Box>
                    <CardContent>
                      <Grid container spacing={2}>
                        <Grid item xs={5}>
                          <Typography>Proposer Name:</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            <strong>{transferData?.proposerName ?? ""}</strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography>Policy Type:</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            <strong>
                              {transferData?.number_of_insured > 1
                                ? "Floater"
                                : "Individual"}
                            </strong>
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography>Number of Insured(s):</Typography>
                        </Grid>
                        <Grid item xs={7}>
                          <Typography>
                            {transferData?.number_of_insured ?? 0}
                          </Typography>
                        </Grid>
                        <hr />
                      </Grid>
                    </CardContent>

                    {/* <div className="flex justify-center items-center mt-4 p-2 text-4xl text-slate-400 font-semibold">
                      Thank You!
                    </div> */}
                  </Card>

                  <div className="flex flex-col items-centers justify-around gap-3 mt-4">
                    <div
                      className="flex items-center justify-center hover:bg-blue-500  bg-blue-800 p-3 text-slate-200 border border-solid border-black rounded-xl text-lg font-semibold h-45 tracking-wide"
                      onClick={() => handleButtonClick("proposalPath")}
                    >
                      Download Proposal Form
                    </div>
                    <div
                      className="flex items-center justify-center hover:bg-blue-500 bg-blue-800 p-3 text-slate-200 border border-solid border-black rounded-xl text-lg font-semibold h-45 tracking-wide"
                      type="button"
                      onClick={() => handleButtonClick("schedulePath")}
                    >
                      Download Policy Schedule
                    </div>
                    <div
                      className="flex items-center justify-center hover:bg-blue-500 bg-blue-800 p-3 text-slate-200 border border-solid border-black rounded-xl text-lg font-semibold h-45 tracking-wide"
                      type="button"
                      onClick={() => handleButtonClick("ecardPath")}
                    >
                      Download E-card
                    </div>
                    <div
                      className="flex items-center justify-center hover:bg-slate-500 hover:text-slate-200 bg-slate-300 p-3 text-slate-800 border border-solid border-black rounded-xl text-lg font-semibold h-45 tracking-wide"
                      type="button"
                      onClick={handleBack}
                    >
                      Back To Home
                    </div>
                  </div>
                </Container>
              </div>
            )
          )}
        </div>
      )}
    </div>
  );
};

export default GoDigitDownloadPage;
